import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";

import { useMemo } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import moment from "moment";
import { useFormik } from "formik";
import { DateRangePicker } from "rsuite";
import { BiExport, BiReset, BiSearch } from "react-icons/bi";
import { Stack } from 'rsuite';
import startOfMonth from 'date-fns/startOfMonth';
import Sidebar from "../../includes/Sidebar";
import { convertDateToStr, downloadXl, predefinedBottomRanges } from "../../../functions";
import { useDispatch, useSelector } from "react-redux";
import { selectIsSuperUser, selectPermissions } from "../../../slice/user/userSlice";
import { Tooltip } from "@mui/material";
import { seErrorMessage } from "../../../slice/error/errorSlice";
import { InvoiceReportService } from "../../../services/InvoiceReportService";
import DownloadDropDown from "../../components/DownloadDropDown";
import { LockBoxFileMonitoringService } from "../../../services/LockBoxFileMonitoringService";
import { DataListService } from "../../../services/DataListService";
import PartnerDropDown from "../../components/PartnerDropDown";
import ClientDropDown from "../../components/ClientDropDown";
import FacilityDropDown from "../../components/FacilityDropDown";
import { BsCloudDownloadFill } from "react-icons/bs";
import toast from 'react-hot-toast';
import Select from 'react-select';
import { IoIosSwitch } from "react-icons/io";
import { MdOutlineHistory } from "react-icons/md";



const datatableCustomStyles = {
    rows: {
        style: {
            minHeight: '20px', // override the row height
            fontSize: '0.7em',
            fontColor: '#212529 !important',
            width: '100%'
        },
    },
    headCells: {
        style: {
            paddingLeft: '5px', // override the cell padding for head cells
            paddingRight: '5px',
            textTransform: "uppercase",
            fontSize: '0.7em',
            fontWeight: '800',
            fontColor: '#6c757d !important',
            opacity: 1,
            minHeight: "10px",
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
            width: "100%",
        },
    },
    pagination: {
        style: {
            color: '#000',
            fontSize: '13px',
            minHeight: '56px',
            backgroundColor: '#fff',
            borderTopStyle: 'solid',
            borderTopWidth: '1px',
            borderTopColor: '#f2f2f2',
        },
        pageButtonsStyle: {
            borderRadius: '50%',
            height: '40px',
            width: '40px',
            padding: '8px',
            margin: '0px',
            cursor: 'pointer',
            transition: '0.4s',
            color: '#000',
            fill: '#000',
            backgroundColor: 'transparent',
            '&:disabled': {
                cursor: 'unset',
                color: '#e2e2e2',
                fill: '#e2e2e2',
            },
            '&:hover:not(:disabled)': {
                backgroundColor: '#f2f2f2',
            },
            '&:focus': {
                outline: 'none',
                backgroundColor: '#f5f5f5',
            },
        },
    },
};

function LockBoxFileMonitoring() {
    const dispatch = useDispatch()
    const dataListService = new DataListService();
    const lockBoxFileMonitoringService = new LockBoxFileMonitoringService();
    const invoiceReportService = new InvoiceReportService()

    const { getLockBoxFileMonitoringSummery, downloadLockBoxFileMonitoringSummery, getFileAuditLogs } = lockBoxFileMonitoringService
    const { getFacilityDropdown, getAllClientDropdown } = invoiceReportService
    const { getAnalyticsUserlist } = dataListService;
    const [staffList, setStaffList] = useState([]);

    const [pageno, setPageNo] = useState(1);
    const [loading, setLoading] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [isTimeCount, setisTimeCount] = useState(false);
    const [totalRows, setTotalRows] = useState(100);
    const [colorRow, setColorRow] = React.useState({});
    const [data, setData] = useState({})
    const [limit, setLimit] = useState(100)
    const [isDisableButton, setIsDisableButton] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [downloadProgress, setDownloadProgress] = useState({ current: 0, total: 0, isDownloading: false });
    // ---- Audit Log Modal ----
    const [showLogModal, setShowLogModal] = useState(false);
    const [logData, setLogData] = useState([]);
    const [logTotalRows, setLogTotalRows] = useState(0);
    const [logPage, setLogPage] = useState(1);
    const [logLimit, setLogLimit] = useState(100);
    const [logLoading, setLogLoading] = useState(false);
    const [isFocusedLogUser, setIsFocusedLogUser] = useState(false);
    const [logTableKey, setLogTableKey] = useState(0);
    const [tableKey, setTableKey] = useState(0);
    const modalRef = useRef();
    const [state, setState] = useState({
      
        'PARTNER NAME': true,
        'CLIENT NAME': true,
        'FACILITY NAME': true,
        "DEPOSIT DATE": true,
        "RECEIVED DATE": true,
        "INTERNAL TAT": true,
        "EXTERNAL TAT": true,
        "OUTPUT GENERATED DATE":true ,
        "OUTPUT SEND DATE":true ,
        'LOCKBOX TYPE': true,
        'RECEIVED LOCKBOX': true,
        'INDEX FILE': true,
        'OPERATION LOG': true,
        'CONVERSION REPORT': true,
        'CREDIT CARD REPORT': true,
        'EXCEPTION REPORT': true,
        'IMAGE SNIPPETS REPORT': true,
        'EPIC OUTPUT': true,
        'FIX LENGTH EPIC OUTPUT': true,
        'FIX LENGTH PP OUTPUT': true,
        'ORPHANED REPORT': true,
    });
    

    const [searchedData, setSearchedData] = useState({
        search: "",
        station: "",
        job_status: "",
        hour_count: "",
        clients: [],
        facilities: [],
        partner: [],
        file_type: "",
        deposit_date_range: [
            new Date(new Date().setHours(0, 0, 0, 0)),
            new Date(new Date().setHours(23, 59, 59, 999))
        ],
        build_date_range: [
            new Date(new Date().setHours(0, 0, 0, 0)),
            new Date(new Date().setHours(23, 59, 59, 999))
        ],
        output_generated_range: [
            new Date(new Date().setHours(0, 0, 0, 0)),
            new Date(new Date().setHours(23, 59, 59, 999))
        ],
        internal_tat_range: [
            new Date(new Date().setHours(0, 0, 0, 0)),
            new Date(new Date().setHours(23, 59, 59, 999))
        ],
        output_send_date_range: [
            new Date(new Date().setHours(0, 0, 0, 0)),
            new Date(new Date().setHours(23, 59, 59, 999))
        ]
    })

    const [isInitSearch, setIsInitSearch] = useState(true)

    const permissions = useSelector(selectPermissions);
    const isSuperUser = useSelector(selectIsSuperUser);
    const isHavePermission = (name) => {
        return permissions?.includes(name) || isSuperUser
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setLimit(newPerPage);
        setTableKey(prev => prev + 1);
        fetchData(1, newPerPage, searchedData);
    };

    const handlePageChange = page => {
        fetchData(page, limit, searchedData);
    };

    const fetchData = (page, limit, params) => {
        setLoading(true);
        setisTimeCount(params?.hour_count == 'true' || params?.hour_count == '' ? false : true);
        const output_generated_time1 = convertDateToStr(params?.output_generated_range, true)
        const build_date_range1 = convertDateToStr(params?.build_date_range, true)
        const internal_tat_range1 = convertDateToStr(params?.internal_tat_range, true)
        const output_send_date_range1 = convertDateToStr(params?.output_send_date_range, true)
        const deposit_date_range1 = convertDateToStr(params?.deposit_date_range, false)

        getLockBoxFileMonitoringSummery(
            {
                page: page,
                limit: limit,
                station: params?.station,
                date_range: params?.date_range ?? "",
                hour_count: params?.hour_count,
                clients: params?.clients,
                facilities: params?.facilities,
                partners: params?.partners,
                deposit_date_range: deposit_date_range1,
                build_date_range: build_date_range1,
                output_generated_range: output_generated_time1,
                internal_tat_range: internal_tat_range1,
                output_send_date_range: output_send_date_range1,
                file_type: params?.file_type,
                filename: params?.filename ?? '',
                export_type: params?.export? params?.export :false,
                sort_order:params?.sort_order ? params?.sort_order : '',
                sort_key:params?.sort_key ? params?.sort_key : '',
            }
        ).then((response) => {
            setData(response?.data);
            setLimit(limit);
            setPageNo(page);
            setTotalRows(response?.data?.count);
            setLoading(false);
            if (response?.errors?.date_range) {
                dispatch(seErrorMessage({ message: response?.errors?.date_range[0], is_show: true }));
            }
        });
    }
  

    const searchFormik = useFormik({
        initialValues: {
            partners: [],
            clients: [],
            facilities: [],
            filename: "",
            file_type: "all",
            deposit_date_range: [
                new Date(new Date().setHours(0, 0, 0, 0)),
                new Date(new Date().setHours(23, 59, 59, 999))
            ],
            build_date_range:"",
            output_generated_range: "",
            internal_tat_range: "",
            output_send_date_range: ""
        },
        validate: (value) => {
            const errors = {};
            const dateFields = ['deposit_date_range', 'build_date_range', 'output_generated_range', 'internal_tat_range', 'output_send_date_range'];
            const hasAnyDate = dateFields.some(f => Array.isArray(value[f]) && value[f].length > 0);
            if (!hasAnyDate) {
                errors.date_required = 'At least one date range is required.';
            }
            return errors;
        },
        onSubmit: (values) => {
            setIsInitSearch(false)
            searchFormik.setFieldValue('sort_key','')
            searchFormik.setFieldValue('sort_order','')
            setSearchedData(values)
           setTableKey(prev => prev + 1);
           setSelectedRows([])
            fetchData(1, limit, values)
        }
    })
    console.log(searchFormik.values, 'formik.values')
    const columns = useMemo(
        () => [
            {
                id: 'S.NO',
                name: 'S.NO',
                selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
                wrap: true,
                width: "40px",
                grow: 0.1,
                omit:!state['S.NO'],

            },
            {
                id: 'partner_name',
                name: 'Partner Name',
                selector: row => row?.partner_name,
                cell: (row) =>
                    <div>
                        {row?.partner_name &&

                            <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ maxWidth: '170px' }}>
                                <div className='overflow-hidden text-truncate' style={{ maxWidth: "120px" }} >
                                    <Tooltip disableInteractive title={row?.partner_name} placement="top" arrow>
                                        <span className="text-truncate" > {row?.partner_name}</span>
                                    </Tooltip>
                                </div>
                            </div>

                        }
                    </div>
                ,
                left: true,
                wrap: true,
                reorder: false,
                grow: 0.1,
                minWidth: '140px',
                expandOnRowClicked: true,
                sortable: true,
                exportKey:"PARTNER NAME",
                sortField: 'partner_name',
                omit:!state['PARTNER NAME'],

            },
            {
                id: 'CLIENT NAME',
                name: 'CLIENT NAME',
                selector: row => row?.client_name,
                cell: (row) =>
                    <div>
                        {row?.client_name &&

                            <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ maxWidth: '170px' }}>
                                <div className='overflow-hidden text-truncate' style={{ maxWidth: "120px" }} >
                                    <Tooltip disableInteractive title={row?.client_name} placement="top" arrow>
                                        <span className="text-truncate" > {row?.client_name}</span>
                                    </Tooltip>
                                </div>
                            </div>

                        }
                    </div>
                ,


                left: true,
                wrap: true,
                reorder: false,
                grow: 0.1,
                minWidth: '130px',
                expandOnRowClicked: true,
                sortable: true,
                exportKey:"CLIENT NAME",
                sortField: 'client_name',
                omit:!state['CLIENT NAME'],

            },
            {
                id: 'FACILITY NAME',
                name: 'FACILITY NAME',
                selector: row => row?.facility_name,
                cell: (row) =>
                    <div>
                        {row?.facility_name &&

                            <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '170px' }}>
                                <div className='overflow-hidden text-truncate' style={{ width: "120px" }} >
                                    <Tooltip disableInteractive title={row?.facility_name} placement="top" arrow>
                                        <span className="text-truncate" > {row?.facility_name}</span>
                                    </Tooltip>
                                </div>
                            </div>

                        }
                    </div>
                ,


                left: true,
                wrap: true,
                reorder: false,
                grow: 0.1,
                minWidth: '130px',
                 exportKey:"FACILITY NAME",       
                expandOnRowClicked: true,
                sortable: true,
                sortField: 'facility_name',
                omit:!state['FACILITY NAME'],

            },
            {
                id: "DEPOSIT DATE",
                name: "DEPOSIT DATE",
                exportKey: "DEPOSIT DATE",
                selector: (row) => moment(row?.deposit_date).format("MM/DD/YY"),
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.deposit_date}</span>,
                left: true,
                wrap: true,
                minWidth: '100px',
                maxWidth: '100px',
                sortable: true,
                omit:!state['DEPOSIT DATE'],
                sortField: 'deposit_date',
            },
            {
                id: "CREATED DATE",
                name: "RECEIVED DATE",
                exportKey: "RECEIVED DATE",
                selector: (row) => moment(row?.created_date).format("MM/DD/YYYY HH:mm"),
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.created_date}</span>,
                left: true,
                wrap: true,
                minWidth: '100px',
                maxWidth: '100px',
                sortable: true,
                omit:!state['RECEIVED DATE'],
                sortField: 'created_date',
            },
            {
                id: "INTERNAL TAT",
                name: "INTERNAL TAT",
                exportKey: "INTERNAL TAT",
                selector: (row) => moment(row?.internal_tat).format("MM/DD/YYYY HH:mm"),
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.internal_tat}</span>,
                left: true,
                wrap: true,
                minWidth: '100px',
                maxWidth: '100px',
                sortable: true,
                omit:!state['INTERNAL TAT'],
                sortField: 'internal_tat',
            },
            {
                id: "EXTERNAL TAT",
                name: "EXTERNAL TAT",
                exportKey: "EXTERNAL TAT",
                selector: (row) => moment(row?.external_tat).format("MM/DD/YYYY HH:mm"),
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.external_tat}</span>,
                left: true,
                wrap: true,
                minWidth: '100px',
                maxWidth: '100px',
                sortable: true,
                omit:!state['EXTERNAL TAT'],
                sortField: 'external_tat',
            },
            {
                id: "OUTPUT GENERATED DATE",
                name: "OUTPUT GENERATED DATE",
                exportKey: "OUTPUT GENERATED DATE",
                selector: (row) => moment(row?.output_generated_time).format("MM/DD/YYYY HH:mm"),
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.output_generated_time }</span>,
                left: true,
                wrap: true,
                minWidth: '100px',
                maxWidth: '100px',
                sortable: true,
                omit:!state['OUTPUT GENERATED DATE'],
                sortField: 'output_generated_time',
            },
            {
                id: "OUTPUT SEND DATE",
                name: "OUTPUT SEND DATE",
                exportKey: "OUTPUT SEND DATE",
                selector: (row) => moment(row?.output_send_date).format("MM/DD/YYYY HH:mm"),
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.output_send_date }</span>,
                left: true,
                wrap: true,
                minWidth: '100px',
                maxWidth: '100px',
                sortable: true,
                omit:!state['OUTPUT SEND DATE'],
                sortField: 'output_send_date',
            },
            {
                id: 'LOCKBOX TYPE',
                name: 'LOCKBOX TYPE',
                exportKey: "LOCKBOX TYPE",
                selector: row => row?.lockbox_type,
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.lockbox_type ?? row?.lockbox_type}</span>,
                left: true,
                wrap: true,
                reorder: false,
                minWidth: '100px',
                maxWidth: '100px',
                sortable: true,
                omit:!state['LOCKBOX TYPE'],
                sortField: 'lockbox_type',      
            },
            {
                id: 'RECEIVED LOCKBOX',
                name: 'RECEIVED LOCKBOX',
                exportKey: "RECEIVED LOCKBOX",
                selector: row => row?.received_lockbox_name,
                cell: (row) => <div>
                    {row?.received_lockbox_name &&

                        <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '170px' }}>
                            <div className='overflow-hidden text-truncate' style={{ width: "120px" }} >
                                <Tooltip disableInteractive title={row?.received_lockbox_name} placement="top" arrow>
                                    <span className="text-truncate" > {row?.received_lockbox_name}</span>
                                </Tooltip>
                            </div>
                        </div>

                    }
                </div>,
                left: true,
                wrap: true,
                reorder: false,
                minWidth: '130px',
                maxWidth: '130px',
                sortable: true,
                omit:!state['RECEIVED LOCKBOX'],
                sortField: 'received_lockbox_name',     
            },
            {
                id: 'INDEX FILE',
                name: 'INDEX FILE',
                exportKey: "INDEX FILE",
                selector: row => row?.index_file_name,
                cell: (row) => <div>
                    {row?.index_file_name &&

                        <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '170px' }}>
                            <div className='overflow-hidden text-truncate' style={{ width: "120px" }} >
                                <Tooltip disableInteractive title={row?.index_file_name} placement="top" arrow>
                                    <span className="text-truncate" > {row?.index_file_name}</span>
                                </Tooltip>
                            </div>
                        </div>

                    }
                </div>,
                left: true,
                wrap: true,
                reorder: false,
                minWidth: '130px',
                maxWidth: '130px',
                omit:!state['INDEX FILE'],
                     
            },
            {
                id: 'OPERATION LOG',
                name: 'OPERATION LOG',
                exportKey: "OPERATION LOG",
                selector: row => row?.operation_log_name,
                cell: (row) => <div>
                    {row?.operation_log_name &&

                        <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '170px' }}>
                            <div className='overflow-hidden text-truncate' style={{ width: "120px" }} >
                                <Tooltip disableInteractive title={row?.operation_log_name} placement="top" arrow>
                                    <span className="text-truncate" > {row?.operation_log_name}</span>
                                </Tooltip>
                            </div>
                        </div>

                    }
                </div>,
                left: true,
                wrap: true,
                reorder: false,
                minWidth: '130px',
                maxWidth: '130px',
                omit:!state['OPERATION LOG'],

            },
            {
                id: 'CONVERSION REPORT',
                name: 'CONVERSION REPORT',
                exportKey: "CONVERSION REPORT",
                selector: row => row?.conversion_report_name,
                cell: (row) => <div>
                    {row?.conversion_report_name &&

                        <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '170px' }}>
                            <div className='overflow-hidden text-truncate' style={{ width: "120px" }} >
                                <Tooltip disableInteractive title={row?.conversion_report_name} placement="top" arrow>
                                    <span className="text-truncate" > {row?.conversion_report_name}</span>
                                </Tooltip>
                            </div>
                        </div>

                    }
                </div>,
                left: true,
                wrap: true,
                reorder: false,
                minWidth: '130px',
                maxWidth: '130px',
                omit:!state['CONVERSION REPORT'],

            },
            {
                id: 'CREDIT CARD REPORT',
                name: 'CREDIT CARD REPORT',
                exportKey: "CREDIT CARD REPORT",
                selector: row => row?.credit_card_report_name,
                cell: (row) => <div>
                    {row?.credit_card_report_name &&

                        <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '170px' }}>
                            <div className='overflow-hidden text-truncate' style={{ width: "120px" }} >
                                <Tooltip disableInteractive title={row?.credit_card_report_name} placement="top" arrow>
                                    <span className="text-truncate" > {row?.credit_card_report_name}</span>
                                </Tooltip>
                            </div>
                        </div>

                    }
                </div>,
                left: true,
                wrap: true,
                reorder: false,
                minWidth: '130px',
                maxWidth: '130px',
                omit:!state['CREDIT CARD REPORT'],

            },
            {
                id: 'EXCEPTION REPORT',
                name: 'EXCEPTION REPORT',
                exportKey: "EXCEPTION REPORT",
                selector: row => row?.exception_report_name,
                cell: (row) => <div>
                    {row?.exception_report_name &&

                        <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '170px' }}>
                            <div className='overflow-hidden text-truncate' style={{ width: "120px" }} >
                                <Tooltip disableInteractive title={row?.exception_report_name} placement="top" arrow>
                                    <span className="text-truncate" > {row?.exception_report_name}</span>
                                </Tooltip>
                            </div>
                        </div>

                    }
                </div>,
                left: true,
                wrap: true,
                reorder: false,
                minWidth: '130px',
                maxWidth: '130px',
                omit:!state['EXCEPTION REPORT'],

            },
            {
                id: 'IMAGE SNIPPETS REPORT',
                name: 'IMAGE SNIPPETS REPORT',
                exportKey: "IMAGE SNIPPETS REPORT",
                selector: row => row?.image_snippets_report_name,
                cell: (row) => <div>
                    {row?.image_snippets_report_name &&

                        <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '170px' }}>
                            <div className='overflow-hidden text-truncate' style={{ width: "120px" }} >
                                <Tooltip disableInteractive title={row?.image_snippets_report_name} placement="top" arrow>
                                    <span className="text-truncate" > {row?.image_snippets_report_name}</span>
                                </Tooltip>
                            </div>
                        </div>

                    }
                </div>,
                left: true,
                wrap: true,
                reorder: false,
                minWidth: '130px',
                maxWidth: '130px',
                omit:!state['IMAGE SNIPPETS REPORT'],

            },
            {
                id: 'EPIC OUTPUT',
                name: 'EPIC OUTPUT',
                exportKey: "EPIC OUTPUT",
                selector: row => row?.epic_output_name,
                cell: (row) => <div>
                    {row?.epic_output_name &&

                        <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '170px' }}>
                            <div className='overflow-hidden text-truncate' style={{ width: "120px" }} >
                                <Tooltip disableInteractive title={row?.epic_output_name} placement="top" arrow>
                                    <span className="text-truncate" > {row?.epic_output_name}</span>
                                </Tooltip>
                            </div>
                        </div>

                    }
                </div>,
                left: true,
                wrap: true,
                reorder: false,
                minWidth: '130px',
                maxWidth: '130px',
                omit:!state['EPIC OUTPUT'],

            },
            {
                id: 'FIX LENGTH EPIC OUTPUT',
                name: 'FIX LENGTH EPIC OUTPUT',
                exportKey: "FIX LENGTH EPIC OUTPUT",
                selector: row => row?.fix_length_epic_output_name,
                cell: (row) => <div>
                    {row?.fix_length_epic_output_name &&

                        <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '170px' }}>
                            <div className='overflow-hidden text-truncate' style={{ width: "120px" }} >
                                <Tooltip disableInteractive title={row?.fix_length_epic_output_name} placement="top" arrow>
                                    <span className="text-truncate" > {row?.fix_length_epic_output_name}</span>
                                </Tooltip>
                            </div>
                        </div>

                    }
                </div>,
                left: true,
                wrap: true,
                reorder: false,
                minWidth: '130px',
                maxWidth: '130px',
                omit:!state['FIX LENGTH EPIC OUTPUT'],

            },
            {
                id: 'FIX LENGTH PP OUTPUT',
                name: 'FIX LENGTH PP OUTPUT',
                exportKey: "FIX LENGTH PP OUTPUT",
                selector: row => row?.fix_length_pp_output_name,
                cell: (row) => <div>
                    {row?.fix_length_pp_output_name &&

                        <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '170px' }}>
                            <div className='overflow-hidden text-truncate' style={{ width: "120px" }} >
                                <Tooltip disableInteractive title={row?.fix_length_pp_output_name} placement="top" arrow>
                                    <span className="text-truncate" > {row?.fix_length_pp_output_name}</span>
                                </Tooltip>
                            </div>
                        </div>

                    }
                </div>,
                left: true,
                wrap: true,
                reorder: false,
                minWidth: '130px',
                maxWidth: '130px',
                omit:!state['FIX LENGTH PP OUTPUT'],

            },
            {
                id: 'ORPHANED REPORT',
                name: 'ORPHANED REPORT',
                exportKey: "ORPHANED REPORT",
                selector: row => row?.orphaned_report_name,
                cell: (row) => <div>
                    {row?.orphaned_report_name &&

                        <div onClick={() => handleRowClick(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '170px' }}>
                            <div className='overflow-hidden text-truncate' style={{ width: "120px" }} >
                                <Tooltip disableInteractive title={row?.orphaned_report_name} placement="top" arrow>
                                    <span className="text-truncate" > {row?.orphaned_report_name}</span>
                                </Tooltip>
                            </div>
                        </div>

                    }
                </div>,
                left: true,
                wrap: true,
                reorder: false,
                minWidth: '130px',
                maxWidth: '130px',
                omit:!state['ORPHANED REPORT'],

            },



        ],

        [limit, pageno, isTimeCount ,state],
    );


      const exportData = (page, limit, params) => {
        setExportLoading(true);
        setisTimeCount(params?.hour_count == 'true' || params?.hour_count == '' ? false : true);
        const output_generated_time1 = convertDateToStr(params?.output_generated_range, true)
        const build_date_range1 = convertDateToStr(params?.build_date_range, true)
        const internal_tat_range1 = convertDateToStr(params?.internal_tat_range, true)
        const output_send_date_range1 = convertDateToStr(params?.output_send_date_range, true)
        const deposit_date_range1 = convertDateToStr(params?.deposit_date_range, false)
        const headers = columns.filter(i => !(i.omit || i.exportKey == undefined)).map(i => i.exportKey)
        getLockBoxFileMonitoringSummery(
            {
                page: page,
                limit: limit,
                station: params?.station,
                date_range: params?.date_range ?? "",
                hour_count: params?.hour_count,
                clients: params?.clients,
                facilities: params?.facilities,
                partners: params?.partners,
                deposit_date_range: deposit_date_range1,
                build_date_range: build_date_range1,
                output_generated_range: output_generated_time1,
                internal_tat_range: internal_tat_range1,
                output_send_date_range: output_send_date_range1,
                file_type: params?.file_type,
                export_type: params?.export? params?.export :false,
                sort_order:params?.sort_order ? params?.sort_order : '',
                sort_key:params?.sort_key ? params?.sort_key : '',
                header_names: headers,
            }
        ).then((response) => {
            setExportLoading(false);
            if(response?.status){
                downloadXl(response?.data)
                if (response?.errors?.date_range) {
                    dispatch(seErrorMessage({ message: response?.errors?.date_range[0], is_show: true }));
                }
            }else{
                toast.error('No data to export ')
            }
        });
    }

    var i = 0;
    const conditionalRowStyles = [

        {
            when: row => colorRow.id == row.id ? true : false,
            style: (row, index) => ({
                backgroundColor: colorRow?.id == row.id ? '#dbf4f5' : '#f2f2f2',
                color: 'black',
                // fontWeight: '550'
            }),
        },


    ];
    const handleRowClick = (row) => {
        setColorRow(row);
    };

    const handleMultipleDownload = () => {
        if (selectedRows.length === 0) return;
        if (searchedData?.file_type != '837') {
            downloadFormik.resetForm();
        }
        if(searchedData?.file_type === '837'){

                downloadFormik.setFieldValue('comment', '')
        }
        setShowDownloadModal(true);
    }

    const FILE_TYPE_OPTIONS = searchedData?.file_type === '837' ?
        [
            { value: 'received_lockbox', label: 'Received Lockbox' }
        ]
        : [
            { value: 'received_lockbox', label: 'Received Lockbox' },
            { value: 'index_file', label: 'Index File' },
            { value: 'operation_log', label: 'Operation Log' },
            { value: 'conversion_report', label: 'Conversion Report' },
            { value: 'credit_card_report', label: 'Credit Card Report' },
            { value: 'exception_report', label: 'Exception Report' },
            { value: 'image_snippets_report', label: 'Image Snippets Report' },
            { value: 'epic_output', label: 'Epic Output' },
            { value: 'fix_length_epic_output', label: 'Fix Length Epic Output' },
            { value: 'fix_length_pp_output', label: 'Fix Length PP Output' },
            { value: 'orphaned_report', label: 'Orphaned Report' },
        ];
 const handleSort = (column, sortDirection) => {
        const field = column?.sortField ?? '';
        const type = sortDirection === 'desc' ? 'DESC' : 'ASC';
        searchFormik.setFieldValue('sort_key',field);
        searchFormik.setFieldValue('sort_order',type);
        setSearchedData({...searchedData,sort_key:field,sort_order:type})
        fetchData(1, limit, {...searchedData,sort_key:field,sort_order:type});
    };
    // Map from file_type value to the row key holding the file path
    const FILE_TYPE_ROW_KEY_MAP = {
        received_lockbox:       'received_lockbox_name',
        index_file:             'index_file_name',
        operation_log:          'operation_log_name',
        conversion_report:      'conversion_report_name',
        credit_card_report:     'credit_card_report_name',
        exception_report:       'exception_report_name',
        image_snippets_report:  'image_snippets_report_name',
        epic_output:            'epic_output_name',
        fix_length_epic_output: 'fix_length_epic_output_name',
        fix_length_pp_output:   'fix_length_pp_output_name',
        orphaned_report:        'orphaned_report_name',
    };

    const downloadFormik = useFormik({
        initialValues: {
            file_type: '',
            comment: '',
        },
        validate: (values) => {
            const errors = {};
            if (!values.file_type) {
                errors.file_type = 'File type is required';
            }
            if (!values.comment || !values.comment.trim()) {
                errors.comment = 'Comment is required';
            }
            return errors;
        },
        onSubmit: (values, { setSubmitting }) => {
            const rowKey = FILE_TYPE_ROW_KEY_MAP[values.file_type];
            const urlpath = rowKey.split('name')[0] + 'url';
            const paths = selectedRows
                .map(row => row?.[urlpath])
                .filter(row => row !== '');

            if (paths.length === 0) {
                setSubmitting(false);
                toast.error('No downloadable files were found.');
                return;
            }

            const payload = {
                paths: paths,
                file_type: values.file_type,
                comment: values.comment,
                filenames: selectedRows.map(row => row?.[rowKey]).filter(row => row !== ''),
            };

            downloadLockBoxFileMonitoringSummery(payload).then((response) => {
                setSubmitting(false);
                const urls = response?.data?.urls ?? [];
                const failedPaths = response?.data?.failed_paths ?? [];

                if (urls.length === 0) {
                    toast.error('No downloadable files were found.');
                    return;
                }

                // Lock the modal and start sequential downloads
                setDownloadProgress({ current: 0, total: urls.length, isDownloading: true });

                const downloadSequentially = async () => {
                    for (let i = 0; i < urls.length; i++) {
                        const url = urls[i];
                        // Extract a sensible filename from the URL
                        try {
                            const filename = decodeURIComponent(url.split('?')[0].split('/').pop()) || `file_${i + 1}`;
                            const anchor = document.createElement('a');
                            anchor.href = url;
                            anchor.download = filename;
                            anchor.target = '_blank';
                            anchor.rel = 'noopener noreferrer';
                            document.body.appendChild(anchor);
                            anchor.click();
                            document.body.removeChild(anchor);
                        } catch (e) {
                            // continue even if one fails
                        }
                        // Small delay between downloads so browser doesn't block them
                        await new Promise(res => setTimeout(res, 800));
                        setDownloadProgress(prev => ({ ...prev, current: i + 1 }));
                    }

                    setDownloadProgress({ current: 0, total: 0, isDownloading: false });

                    if (failedPaths.length > 0) {
                        toast.error(`${urls.length} file(s) downloaded. ${failedPaths.length} path(s) failed.`, { duration: 5000 });
                    } else {
                        toast.success(`${urls.length} file(s) downloaded successfully!`, { duration: 4000 });
                    }

                    setShowDownloadModal(false);
                };

                downloadSequentially();
            }).catch(() => {
                setSubmitting(false);
                setDownloadProgress({ current: 0, total: 0, isDownloading: false });
                toast.error('Failed to get download URLs. Please try again.');
            });
        },
    });
    const handleReset = () => {
        searchFormik.resetForm();
        setSearchedData({});
        setData([]);
        setIsInitSearch(true)
    };

    // ===================== AUDIT LOG =====================
   

    const fetchAuditLogs = (page, limit, values) => {
        setLogLoading(true);
        const created_date_range = values?.created_date_range
            ? convertDateToStr(values.created_date_range, true)
            : '';
        const users = values?.users ? values.users.join(',') : '';
        const file_type = values?.file_type ?? '';
        getFileAuditLogs({ page, limit, created_date_range, users, file_type })
            .then((response) => {
                setLogData( response?.data ?? []);
                setLogTotalRows(response?.data?.count ?? 0);
                setLogLoading(false);
            })
            .catch(() => {
                setLogLoading(false);
                toast.error('Failed to load audit logs.');
            });
    };

    const logFormik = useFormik({
        initialValues: {
            created_date_range: '',
            users: [],
            file_type: '',
        },
        onSubmit: (values) => {
            setLogPage(1)
            setLogTableKey(prev => prev + 1);   // resets DataTable pagination to page 1 without double-call
            fetchAuditLogs(1, logLimit, values);
        },
    });

    const handleOpenLogModal = () => {
        logFormik.resetForm();
        setLogData([]);
        setLogTotalRows(0);
        setLogTableKey(prev => prev + 1);   // reset pagination
        setShowLogModal(true);
        fetchAuditLogs(1, logLimit, logFormik.initialValues);
    };
    // ======================================================

    const handleOnDateTimeChange = ({ name, value }) => {
        let created_date = ""
        let string_name = name + "_string"
        if (value !== null) {
            const startDate = value[0];
            const endDate = value[1];
            // Check if the start date is after the end date, and swap the dates if needed
            let isGreater = false
            if (startDate > endDate) {
                isGreater = true
            }
            const datefrom = moment(isGreater ? endDate : startDate).format('MM/DD/YYYY HH:mm:ss')
            const dateto = moment(isGreater ? startDate : endDate).format('MM/DD/YYYY HH:mm:ss')

            created_date = datefrom + " - " + dateto
        } else {
            setSearchedData({
                ...searchedData,
                [string_name]: '',
            })
            // fetchData(1, limit, { ...searchedData, [string_name]: '' });
        }

        searchFormik.setValues({ ...searchFormik.values, [string_name]: created_date, [name]: value ?? "" })
    }




    const handleRowSelected = React.useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    useEffect(() => {
        getAnalyticsUserlist().then((response) => {
            setStaffList(response?.data?.results);
        });
    }, []);


    useEffect(() => {
        if (searchedData?.file_type === '837') {
            downloadFormik.setFieldValue('file_type', 'received_lockbox')
        }
    }, [searchedData])
    const handleSerialNumber = (index) => {
        return logPage == 1 ? index + 1 : (logPage - 1) * logLimit + index + 1;
    };

    return (
        <React.Fragment>
            <Sidebar />
            <main id="main" className="main">

                <div className="pagetitle tab-fixed-header">
                    <h1 id='page-title'>Lockbox File Monitoring</h1>
                </div>

                <section className="section mt-5 ">
                    <div className="row align-items-top py-2 gap-2 gap-md-5">
                        <div className="col-lg-12">
                            <div className="card mb-5 mb-xl-8 " style={{ height: "92vh" }}>

                                <Form onSubmit={searchFormik.handleSubmit} onReset={handleReset}    >
                                    <div className=" ">
                                        <div className="px-1 py-1 d-flex flex-row justify-content-start gap-2 align-items-center flex-wrap">

                                            <PartnerDropDown lockboxformik={searchFormik} width="250px" />
                                            <ClientDropDown lockboxformik={searchFormik} width="250px" />
                                            <FacilityDropDown lockboxformik={searchFormik} width="250px" />
                                            <div style={{ minWidth: '180px', position: 'relative' }}>
                                                <Tooltip disableInteractive title={"File Name"} placement="top" arrow>
                                                    <Form.Group>
                                                        <Form.Control
                                                            type="text"
                                                            name="filename"
                                                            placeholder="File Name"
                                                            value={searchFormik.values.filename}
                                                            onChange={searchFormik.handleChange}
                                                            className="form-control form-control-solid b-r-10"
                                                            style={{ borderRadius: '10px', height: '38px', backgroundColor: 'hsl(204, 33%, 97%)', borderStyle: 'none', paddingRight: searchFormik.values.filename ? '28px' : undefined }}
                                                        />
                                                        {searchFormik.values.filename && (
                                                            <button
                                                                type="button"
                                                                onClick={() => searchFormik.setFieldValue('filename', '')}
                                                                style={{
                                                                    position: 'absolute',
                                                                    right: '8px',
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    padding: 0,
                                                                    lineHeight: 1,
                                                                    cursor: 'pointer',
                                                                    color: '#aaa',
                                                                    fontSize: '14px',
                                                                }}
                                                                title="Clear"
                                                            >
                                                                ✕
                                                            </button>
                                                        )}
                                                    </Form.Group>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: "100px" }}>
                                                <Tooltip disableInteractive title={"LockBox Type"} placement="top" arrow>  
                                                <Form.Group>
                                                    <Form.Control as="select"
                                                        name="file_type"
                                                        className='form-control form-control-solid b-r-10'
                                                        value={searchFormik.values?.file_type}
                                                        onChange={searchFormik.handleChange}
                                                        style={{ borderRadius: '10px', height: '38px', backgroundColor: 'hsl(204, 33%, 97%)', borderStyle: 'none' }}
                                                    >
                                                        <option value="all">All</option>
                                                        <option value="eob">EOB</option>
                                                        <option value="837">837</option>
                                                    </Form.Control>
                                                </Form.Group>
                                                </Tooltip>
                                            </div>
                                            <Tooltip disableInteractive title={"Deposit Date"} placement="top" arrow>
                                                <div className="correspondenceDatePicker" style={searchFormik.errors.date_required ? { border: '1px solid #dc3545', borderRadius: '8px' } : {}}>
                                                    <Stack direction="column" spacing={8} alignItems="flex-start">
                                                        <DateRangePicker
                                                            id="deposit_date_range"
                                                            defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                                                            autocomplete="one-time-code"
                                                            ranges={predefinedBottomRanges}
                                                            cleanable
                                                            placement="auto"
                                                            appearance="default" format={"MM/dd/yyyy "}
                                                            className="form-date-control form-control-solid b-r-1 text-dark"
                                                            placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                                                            name="deposit_date_range"
                                                            onChange={(e) => { handleOnDateTimeChange({ name: 'deposit_date_range', value: e }) }}
                                                            value={searchFormik?.values?.deposit_date_range || []}
                                                            />

                                                    </Stack>
                                                </div>
                                            </Tooltip>

                                            <Tooltip disableInteractive title={"Received Date"} placement="top" arrow>
                                                <div className="correspondenceDatePicker" style={searchFormik.errors.date_required ? { border: '1px solid #dc3545', borderRadius: '8px' } : {}}>
                                                    <Stack direction="column" spacing={8} alignItems="flex-start">
                                                        <DateRangePicker
                                                            defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                                                            id="build_date_range"
                                                            autocomplete="one-time-code"
                                                            ranges={predefinedBottomRanges}
                                                            // cleanable={true}
                                                            // isClearable={true}
                                                            appearance="default" 
                                                            format={"MM/dd/yyyy HH:mm"}
                                                            placement="auto"
                                                            className="form-date-control form-control-solid b-r-1 text-dark "
                                                            placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                                                            name="build_date_range"
                                                            onChange={(e) => { handleOnDateTimeChange({ name: 'build_date_range', value: e }) }}
                                                            value={searchFormik?.values?.build_date_range || null}
                                                            />

                                                    </Stack>
                                                </div>
                                            </Tooltip>

                                            <Tooltip disableInteractive title={"Output Generated Date"} placement="top" arrow>
                                                <div className="correspondenceDatePicker " style={searchFormik.errors.date_required ? { border: '1px solid #dc3545', borderRadius: '8px' } : {}}>
                                                    <Stack direction="column" spacing={8} alignItems="flex-start">
                                                        <DateRangePicker
                                                            id="output_generated_range"
                                                            defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                                                            autocomplete="one-time-code"
                                                            ranges={predefinedBottomRanges}
                                                            isClearable
                                                            placement="auto"
                                                            appearance="default" format={"MM/dd/yyyy HH:mm"}
                                                            className="form-date-control form-control-solid b-r-1 text-dark "
                                                            placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                                                            name="output_generated_range"
                                                            onChange={(e) => { handleOnDateTimeChange({ name: 'output_generated_range', value: e }) }}
                                                            value={searchFormik?.values?.output_generated_range || null}
                                                            />

                                                    </Stack>
                                                </div>
                                            </Tooltip>

                                            <Tooltip disableInteractive title={"Output Send Date"} placement="top" arrow>
                                                <div className="correspondenceDatePicker" style={searchFormik.errors.date_required ? { border: '1px solid #dc3545', borderRadius: '8px' } : {}}>
                                                    <Stack direction="column" spacing={8} alignItems="flex-start">
                                                        <DateRangePicker
                                                            id="output_send_date_range"
                                                            defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                                                            autocomplete="one-time-code"
                                                            ranges={predefinedBottomRanges}
                                                            cleanable
                                                            placement="auto"
                                                            appearance="default"
                                                            format={"MM/dd/yyyy HH:mm"}
                                                            className="form-date-control form-control-solid b-r-1 text-dark "
                                                            placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                                                            name="output_send_date_range"
                                                            onChange={(e) => { handleOnDateTimeChange({ name: 'output_send_date_range', value: e }) }}
                                                            value={searchFormik?.values?.output_send_date_range || null}
                                                             />
                                                    </Stack>
                                                </div>
                                            </Tooltip>

                                            <div>
                                                <Tooltip disableInteractive title={"Search"} placement="top" arrow>
                                                    <Button className="btn btn-light btn-active-primary" type="submit" disabled={loading}>
                                                        <span className="svg-icon svg-icon-3">
                                                            
                                                            <BiSearch />
                                                            
                                                        </span>

                                                    </Button>
                                                </Tooltip>
                                            </div>
                                            <Tooltip disableInteractive title="Reset" placement="top" arrow disabled={isDisableButton}>
                                                <Button
                                                    className="btn btn-light btn-active-primary d-flex align-items-center justify-content-center jobMonitor-Buttons"
                                                    //onClick={handleResetCallFetch}
                                                    type="reset"
                                                    disabled={loading}
                                                >
                                                    <span className="svg-icon svg-icon-3">
                                                        <BiReset className="jobMonitor-svg" />
                                                    </span>
                                                </Button>
                                            </Tooltip>
                                            <div className="dropdown">
                                                <button
                                                    className="btn btn-light btn-active-primary d-flex align-items-center justify-content-center dropdown-toggle  jobMonitor-Buttons"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                    disabled={loading}
                                                >
                                                    <IoIosSwitch className="jobMonitor-svg" />
                                                </button>
                                                <ul
                                                    className="dropdown-menu hide-scroll-bar"
                                                    style={{ height: "500px", overflowX: "scroll" }}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    {Object.entries(state).map(([key, value]) => (
                                                        <li key={key}>
                                                            <div className="dropdown-item">
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        checked={value}
                                                                        onChange={() =>
                                                                            setState(prev => ({
                                                                                ...prev,
                                                                                [key]: !prev[key]
                                                                            }))
                                                                        }
                                                                        type="checkbox"
                                                                        id={key}
                                                                    />
                                                                    <label className="form-check-label" htmlFor={key}>
                                                                        {key
                                                                            .split("_")
                                                                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                                            .join(" ")}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            {
                                            isHavePermission("download_lockbox_file_monitoring_files") && 
                                            selectedRows.length>0 &&

                                                <button onClick={() => handleMultipleDownload()} className="btn btn-light btn-active-primary d-flex align-items-center justify-content-center jobMonitor-Buttons" type="button" disabled={loading || exportLoading}>

                                                    <Tooltip disableInteractive title={"Download"} placement="top" arrow>
                                                        <div>
                                                            <BsCloudDownloadFill className='jobMonitor-svg' />
                                                        </div>
                                                    </Tooltip>


                                                </button>
                                            }
                                                  <Tooltip disableInteractive title="Export" placement="top" arrow >
                                                <Button
                                                        disabled={loading || exportLoading}
                                                        className="btn btn-light btn-active-primary d-flex align-items-center justify-content-center jobMonitor-Buttons"
                                                        onClick={() => {
                                                             exportData(1,limit,{...searchFormik?.values,export:true})   
                                                        }}
                                                        type="button"
                                                >
                                                        <span className="svg-icon svg-icon-3">
                                                                {!exportLoading ? (
                                                                        <BiExport className="jobMonitor-svg" />
                                                                ) : (
                                                                    <div className="spinner-border spinner-border-sm text-light" role="status"></div>
                                                                )}
                                                        </span>
                                                </Button>
                                        </Tooltip>



                                            {/* } */}
                                            <Tooltip disableInteractive title="Audit Log" placement="top" arrow>
                                                <Button
                                                    className="btn btn-light btn-active-primary d-flex align-items-center justify-content-center jobMonitor-Buttons"
                                                    onClick={handleOpenLogModal}
                                                    type="button"
                                                    disabled={loading}
                                                >
                                                    <MdOutlineHistory className="jobMonitor-svg" />
                                                </Button>
                                            </Tooltip>

                                        </div>
                                        {/* Date validation error message */}
                                       
                                    </div>

                                </Form>


                                <div className="card-body p-common">
                                    <div className="table-responsive">
                                        <div className="dashboardtable">
                                            {/* {!reRenderDataTable && */}
                                            <DataTable
                                                key={tableKey}
                                                className="custom-datatable"
                                                paginationDefaultPage={1}
                                                noDataComponent={isInitSearch ? <p className="p-4">Apply filters to refine and display the data</p> : <p className="p-4">There are no records to display</p>}
                                                selectableRows
                                                onSelectedRowsChange={handleRowSelected}
                                                fixedHeader={true}
                                                progressPending={loading}
                                                data={data?.results}
                                                columns={columns}
                                                pointerOnHover={true}
                                                pagination
                                                paginationServer
                                                sortServer
                                                onSort={handleSort}
                                                onRowClicked={handleRowClick}
                                                highlightOnHover
                                                paginationTotalRows={totalRows}
                                                paginationPerPage={limit}
                                                paginationRowsPerPageOptions={[25, 50, 100, 150, 200]}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                conditionalRowStyles={conditionalRowStyles}
                                                theme="solarized"
                                                customStyles={datatableCustomStyles}
                                                striped={true}
                                            />
                                            {/* } */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>

            {/* ===== Download Modal ===== */}
            <Modal
                show={showDownloadModal}
                onHide={() => {
                    if (!downloadFormik.isSubmitting && !downloadProgress.isDownloading) {
                        setShowDownloadModal(false);
                    }
                }}
                backdrop={downloadFormik.isSubmitting || downloadProgress.isDownloading ? 'static' : true}
                keyboard={!downloadFormik.isSubmitting && !downloadProgress.isDownloading}
                centered
            >
                <Modal.Header closeButton={!downloadFormik.isSubmitting && !downloadProgress.isDownloading}>
                    <Modal.Title style={{ fontSize: '1rem', fontWeight: 700 }}>
                        Download Files
                        <div style={{ fontSize: '0.75rem', color: '#6c757d', fontWeight: 400, marginTop: 2 }}>
                            {selectedRows.length} row{selectedRows.length !== 1 ? 's' : ''} selected
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={downloadFormik.handleSubmit}>
                    <Modal.Body>
                        {/* Progress section – shown once download starts */}
                        {downloadProgress.isDownloading && (
                            <div className="mb-3">
                                <div className="d-flex justify-content-between mb-1" style={{ fontSize: '0.82rem', fontWeight: 600 }}>
                                    <span>Downloading files…</span>
                                    <span>{downloadProgress.current} / {downloadProgress.total}</span>
                                </div>
                                <div className="progress" style={{ height: '10px', borderRadius: '6px' }}>
                                    <div
                                        className="progress-bar progress-bar-striped progress-bar-animated"
                                        role="progressbar"
                                        style={{
                                            width: `${downloadProgress.total > 0 ? (downloadProgress.current / downloadProgress.total) * 100 : 0}%`,
                                            backgroundColor: '#1ba1a7'
                                        }}
                                    />
                                </div>
                                <div style={{ fontSize: '0.75rem', color: '#6c757d', marginTop: 6 }}>
                                    Please wait — do not close this window until all files are downloaded.
                                </div>
                            </div>
                        )}

                        {/* Form fields – hidden while downloading */}
                        {!downloadProgress.isDownloading && (
                            <>
                                <Form.Group className="mb-3">
                                    <Form.Label style={{ fontWeight: 600, fontSize: '0.85rem' }}>
                                        File Type
                                    </Form.Label>
                                    <Select
                                        className="basic-single select-search-facility"
                                        classNamePrefix="select"
                                        name="file_type"
                                        options={FILE_TYPE_OPTIONS.filter(opt => opt.value !== '')}
                                        value={FILE_TYPE_OPTIONS.find(opt => opt.value === downloadFormik.values.file_type) || null}
                                        onChange={(selected) => downloadFormik.setFieldValue('file_type', selected ? selected.value : '')}
                                        onBlur={() => downloadFormik.setFieldTouched('file_type', true)}
                                        placeholder=""
                                        isClearable
                                        styles={{
                                            container: (styles) => ({ ...styles, borderRadius: '9px', width: '100%' }),
                                            control: (styles, state) => ({
                                                ...styles,
                                                backgroundColor: 'hsl(204deg 33.33% 97.06%)',
                                                borderStyle: downloadFormik.touched.file_type && downloadFormik.errors.file_type ? 'solid' : 'none',
                                                borderColor: downloadFormik.touched.file_type && downloadFormik.errors.file_type ? '#dc3545' : 'transparent',
                                                boxShadow: 'none',
                                                borderRadius: '10px',
                                                fontSize: '0.85rem',
                                            }),
                                            indicatorSeparator: (styles) => ({ ...styles, width: '0px' }),
                                        }}
                                    />
                                    {downloadFormik.touched.file_type && downloadFormik.errors.file_type && (
                                        <span className="text-danger" style={{ fontSize: '0.78rem' }}>
                                            {downloadFormik.errors.file_type}
                                        </span>
                                    )}
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label style={{ fontWeight: 600, fontSize: '0.85rem' }}>
                                        Comment 
                                    </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        name="comment"
                                        rows={3}
                                        className='form-control form-control-solid b-r-10 h-100'
                                        placeholder="Add a comment"
                                        value={downloadFormik.values.comment}
                                        onChange={downloadFormik.handleChange}
                                        onBlur={downloadFormik.handleBlur}
                                        isInvalid={downloadFormik.touched.comment && !!downloadFormik.errors.comment}
                                        style={{ borderRadius: '8px', fontSize: '0.85rem', resize: 'none' }}
                                    />
                                    {downloadFormik.touched.comment && downloadFormik.errors.comment && (
                                        <span className="text-danger" style={{ fontSize: '0.78rem' }}>
                                            {downloadFormik.errors.comment}
                                        </span>
                                    )}
                                </Form.Group>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            size="sm"
                            onClick={() => setShowDownloadModal(false)}
                            disabled={downloadFormik.isSubmitting || downloadProgress.isDownloading}
                        >
                            Cancel
                        </Button>
                        {!downloadProgress.isDownloading && (
                            <Button
                                className="btn btn-light btn-active-primary"
                                size="sm"
                                type="submit"
                                disabled={downloadFormik.isSubmitting}
                            >
                                {downloadFormik.isSubmitting ? 'Preparing…' : 'Download'}
                            </Button>
                        )}
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* ===== Audit Log Modal ===== */}
            <Modal
                show={showLogModal}
                onHide={() => {setShowLogModal(false);setLogPage(1);setLogLimit(100)}}
                size="xl"
                centered
                ref={modalRef} 
            >
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: '1rem', fontWeight: 700 }}>
                        <MdOutlineHistory style={{ marginRight: 6 }} />
                        Audit Log
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={logFormik.handleSubmit}>
                    <Modal.Body style={{ padding: 0, display: 'flex', flexDirection: 'column', maxHeight: '75vh', overflow: 'hidden' }}>
                        {/* Filters Row - Sticky at top */}
                        <div className="d-flex flex-row flex-wrap gap-2 align-items-end px-3 py-2" style={{ borderBottom: '1px solid #dee2e6', backgroundColor: '#fff', flexShrink: 0 }}>
                            {/* Created Date Range */}
                            <Tooltip title="Received Date" placement="top" arrow>
                            <div>
                                <DateRangePicker
                                    container={() => document.querySelector('.modal')}
                                    defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                                    ranges={predefinedBottomRanges}
                                    cleanable
                                    placement="bottomStart"
                                    appearance="default"
                                    format="MM/dd/yyyy HH:mm"
                                    className="form-date-control form-control-solid b-r-1 text-dark"
                                    placeholder="MM/DD/YYYY - MM/DD/YYYY"
                                    value={logFormik.values.created_date_range || null}
                                    onChange={(val) => logFormik.setFieldValue('created_date_range', val)}
                                    style={{ fontSize: '0.8rem' }}
                                />
                            </div>
                            </Tooltip>
                            {/* Users */}
                            <Tooltip title="Users" placement="top" arrow>
                            <div style={{ minWidth: 220 }}>
                                <Select
                                    isMulti
                                    className="basic-single select-search-facility"
                                    classNamePrefix="select"
                                    menuPortalTarget={document.body}
                                    options={staffList?.map(u => ({ value: u.id ?? u.value, label: u.username ?? u.label })) ?? []}
                                    value={(staffList?.map(u => ({ value: u.id ?? u.value, label: u.username ?? u.label })) ?? []).filter(o => logFormik.values.users.includes(o.value))}
                                    onChange={(sel) => logFormik.setFieldValue('users', sel ? sel.map(s => s.value) : [])}
                                    onFocus={() => setIsFocusedLogUser(true)}
                                    onBlur={() => setIsFocusedLogUser(false)}
                                    placeholder="All Users"
                                    styles={{
                                        container: (s) => ({ ...s, borderRadius: '9px', minWidth: 220 }),
                                        control: (s) => ({ ...s, backgroundColor: 'hsl(204deg 33.33% 97.06%)', borderStyle: 'none', boxShadow: 'none', borderRadius: '10px', fontSize: '0.82rem' }),
                                        indicatorSeparator: (s) => ({ ...s, width: 0 }),
                                        valueContainer: (s) => ({ ...s, maxHeight: isFocusedLogUser ? 'auto' : '34px', overflow: 'hidden' }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </div>
                            </Tooltip>
                            {/* File Type */}
                            <Tooltip title="File Type" placement="top" arrow>
                            <div style={{ minWidth: 160 }}>
                                <Select
                                    className="basic-single select-search-facility"
                                    classNamePrefix="select"
                                    menuPortalTarget={document.body}
                                    options={FILE_TYPE_OPTIONS}
                                    value={FILE_TYPE_OPTIONS.find(o => o.value === logFormik.values.file_type) || null}
                                    onChange={(sel) => logFormik.setFieldValue('file_type', sel ? sel.value : '')}
                                    isClearable
                                    placeholder="All Types"
                                    styles={{
                                        container: (s) => ({ ...s, borderRadius: '9px', minWidth: 160 }),
                                        control: (s) => ({ ...s, backgroundColor: 'hsl(204deg 33.33% 97.06%)', borderStyle: 'none', boxShadow: 'none', borderRadius: '10px', fontSize: '0.82rem' }),
                                        indicatorSeparator: (s) => ({ ...s, width: 0 }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </div>
                            </Tooltip>
                            {/* Search */}
                            <Button type="submit" className="btn btn-light btn-active-primary d-flex align-items-center justify-content-center jobMonitor-Buttons" disabled={logLoading}>
                                <BiSearch className="jobMonitor-svg" />
                            </Button>
                            {/* Reset */}
                            <Button
                                type="button"
                                className="btn btn-light btn-active-primary d-flex align-items-center justify-content-center jobMonitor-Buttons"
                                onClick={() => {
                                    logFormik.resetForm();
                                    setLogTableKey(prev => prev + 1);
                                    fetchAuditLogs(1, logLimit, logFormik.initialValues);
                                }}
                            >
                                <BiReset className="jobMonitor-svg" />
                            </Button>
                        </div>

                        {/* Log Table - DataTable area */}
                        <div style={{ flex: 1, padding: '0 16px' }}>
                        <DataTable
                            columns={[
                                {
                                    name: 'S.NO',
                                    selector: (row, idx) => handleSerialNumber(idx),
                                    width: '55px',
                                    compact: true,
                                },
                                {
                                    name: 'Created Date',
                                    selector: row => row?.created_at ?? row?.created_date ?? '',
                                    cell: row => <span style={{ fontSize: '0.78rem' }}>{row?.created_at ?? row?.created_date ?? '-'}</span>,
                                    wrap: true,
                                    width: '150px',
                                },
                                {
                                    name: 'User',
                                    selector: row => row?.user ?? '',
                                    cell: row =>
                                        <Tooltip
                                            disableInteractive
                                            title={row?.user}
                                            placement="top"
                                            arrow
                                        >
                                            <div className='overflow-hidden text-truncate' style={{ maxWidth: "120px" }} >
                                                <span style={{ fontSize: '0.78rem' }}>{row?.user ?? '-'}</span>
                                            </div>
                                        </Tooltip>,
                                    wrap: true,
                                    width: '120px',
                                },
                                {
                                    name: 'File Type',
                                    selector: row => row?.file_type ?? '',
                                    cell: row =>
                                        <Tooltip
                                            disableInteractive
                                            title={row?.file_type}
                                            placement="top"
                                            arrow
                                        >
                                            <div className='overflow-hidden text-truncate' style={{ maxWidth: "150px" }} >
                                                <span style={{ fontSize: '0.78rem' }}>{row?.file_type ?? '-'}</span>
                                            </div>
                                        </Tooltip>,
                                    width: '150px',
                                },
                                {
                                    name: 'Comment',
                                    selector: row => row?.comment ?? '',
                                    cell: row =>
                                        <Tooltip
                                            disableInteractive
                                            title={row?.comment}
                                            placement="top"
                                            arrow
                                        >
                                            <div className='overflow-hidden text-truncate' style={{ maxWidth: "200px" }} >
                                                <span style={{ fontSize: '0.78rem' }}>{row?.comment ?? '-'}</span>
                                            </div>
                                        </Tooltip>,
                                    wrap: true,
                                    grow: 1,
                                    width: '200px',
                                },
                                {
                                    name: 'Filenames',
                                    selector: row => Array.isArray(row?.filenames) ? row.filenames[0] ?? '-' : (row?.filenames ?? '-'),
                                    cell: row => {
                                        const files = Array.isArray(row?.filenames) ? row.filenames : [];
                                        const tooltipText = files.join('\n');
                                        const displayText = files[0] ?? '-';
                                        const extra = files.length > 1 ? ` +${files.length - 1} more` : '';
                                        return (
                                            <Tooltip
                                                disableInteractive
                                                title={
                                                    <span style={{ whiteSpace: 'pre-line', fontSize: '0.75rem' }}>
                                                        {tooltipText || '-'}
                                                    </span>
                                                }
                                                placement="top"
                                                arrow
                                            >
                                                <span style={{ fontSize: '0.78rem', display: 'block', maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: files.length > 1 ? 'help' : 'default' }}>
                                                    {displayText}
                                                    {extra && <span style={{ color: '#6c757d', marginLeft: 4 }}>{extra}</span>}
                                                </span>
                                            </Tooltip>
                                        );
                                    },
                                    minWidth: '200px',
                                    grow: 1.5,
                                },
                            ]}
                            key={logTableKey}
                            data={logData?.results}
                            progressPending={logLoading}
                            fixedHeader={true}
                            fixedHeaderScrollHeight="calc(75vh - 120px)"
                            pagination
                            paginationServer
                            paginationTotalRows={logTotalRows}
                            paginationPerPage={logLimit}
                            paginationRowsPerPageOptions={[25, 50, 100]}
                            onChangePage={(page) => {
                                setLogPage(page);
                                fetchAuditLogs(page, logLimit, logFormik.values);
                            }}
                            onChangeRowsPerPage={(newLimit) => {
                                setLogLimit(newLimit);
                                setLogTableKey(prev => prev + 1);
                                fetchAuditLogs(1, newLimit, logFormik.values);
                            }}
                            noDataComponent={<p className="p-3" style={{ fontSize: '0.82rem' }}>No audit log records found.</p>}
                            customStyles={datatableCustomStyles}
                            theme="solarized"
                            dense
                        />
                        </div>
                    </Modal.Body>
                </Form>
            </Modal>

        </React.Fragment >
    )
}
export default LockBoxFileMonitoring




